import { render } from "./ProductByDepartList.vue?vue&type=template&id=4abf5cfa&scoped=true"
import script from "./ProductByDepartList.vue?vue&type=script&lang=js"
export * from "./ProductByDepartList.vue?vue&type=script&lang=js"

import "./ProductByDepartList.vue?vue&type=style&index=0&id=4abf5cfa&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4abf5cfa"]])

export default __exports__